import React, { Component } from 'react';
import './HelpModal.css';
import { FormattedMessage } from 'react-intl';
import messages from '../lang/preferences';

export default class HelpModal extends Component {
  state = {
    isOpen: false
  }
  switchMenu = () => {
    if(this.state.isOpen === false ){
      this.setState({
        isOpen: true,
      })
    }
    else{
      this.setState({
        isOpen: false,
      })
    }
  }
  render() {
    return (
      <React.Fragment>
        {
          this.state.isOpen ?
            <div className="HelpModal HelpModal-isOpen" >
              <div className="HelpModal-content">
              {
                this.props.dataTitles.map((title, index) => {
                  const description = this.props.dataDescriptions[index];
                  return (
                    <div className="HelpModal-title-description">
                      <b><FormattedMessage {...messages[title]} /> : </b>
                      <FormattedMessage {...messages[description]} /> 
                    </div>
                  )
                })
              }
              </div>
              <div className="HelpModal-close" onClick={() => this.switchMenu()}>X</div>
            </div>
          :
            <div className="HelpModal HelpModal-isNotOpen" onClick={() => this.switchMenu()}>
              ?
            </div>
        }
      </React.Fragment>
    )
  }
}
